import reducer from "./reducer";
export { default as TotemManagement } from "./components/index";
export { default as totemManagementReducerName } from "./constants";
export default reducer;
